import type { Profile } from '@/types/user'

/** Сотрудник Стрижа (полный доступ к административной панели) */
export function isStaff(profile: Profile | null | undefined): boolean {
  return profile?.role === 'admin' || profile?.role === 'dispatcher'
}

/** Менеджер или руководитель компании-заказчика */
export function isCustomerUser(profile: Profile | null | undefined): boolean {
  if (!profile) return false
  return (
    (profile.role === 'manager' || profile.role === 'customer_supervisor') &&
    profile.company_type === 'customer'
  )
}

/** Менеджер заказчика — видит только свои заказы */
export function isCustomerManager(profile: Profile | null | undefined): boolean {
  return isCustomerUser(profile) && profile?.role === 'manager'
}

/** Руководитель заказчика — видит заказы своей компании */
export function isCustomerSupervisor(
  profile: Profile | null | undefined,
): boolean {
  return isCustomerUser(profile) && profile?.role === 'customer_supervisor'
}

/** Сотрудник компании-партнёра воронки лидов (СберАвто и т. п.): видит только
 *  кабинет партнёра (/partner), данные — через RPC partner_* */
export function isPartner(profile: Profile | null | undefined): boolean {
  return profile?.role === 'partner_operator' || profile?.role === 'partner_viewer'
}

/** Пользователь компании-исполнителя */
export function isContractorUser(profile: Profile | null | undefined): boolean {
  if (!profile) return false
  return (
    (profile.role === 'inspector' || profile.role === 'contractor_supervisor') &&
    profile.company_type === 'contractor'
  )
}
